window.getLocale = function () {
    return document.documentElement.getAttribute("lang");
};
